import React from 'react';
import { BookOpenIcon, GiftIcon, FileTextIcon, CalendarRangeIcon, GemIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustLine } from './TrustLine';
const miniBadges = [{
  Icon: BookOpenIcon,
  label: '6 Volumes'
}, {
  Icon: GiftIcon,
  label: '5 Bonuses'
}, {
  Icon: FileTextIcon,
  label: '300+ Pages'
}, {
  Icon: CalendarRangeIcon,
  label: 'One volume per phase'
}, {
  Icon: GemIcon,
  label: 'Any budget, any guest count'
}];
export function Hero() {
  return <section aria-labelledby="hero-heading" className="w-full bg-ivory" data-id="element-116" data-mp="xa4j3hgrojhp">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 pt-10 pb-14 sm:pt-16 sm:pb-20" data-id="element-117" data-mp="sbb57nxkiqh0">
        <div className="grid lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] gap-10 lg:gap-14 items-center" data-id="element-118" data-mp="sd4bv386lap0">
          <div data-id="element-119" data-mp="3d1ii934hv0k9">
            <p className="flex items-center gap-2 text-[13px] font-semibold uppercase tracking-kicker text-sage-deep" data-id="element-120" data-mp="3d21uc37gquqd">
              <span aria-hidden="true" data-id="element-121" data-mp="381e0zavri1sz">◆</span>
              The 12-Month Wedding Plan™ — Organized by WHEN, not by what
            </p>

            <h1 id="hero-heading" className="mt-5 font-serif font-normal text-ink text-[36px] leading-[1.08] sm:text-[46px] lg:text-[52px] lg:leading-[1.06] tracking-[-0.01em]" data-id="element-122" data-mp="3j6fx1mlet7c9">
              Plan your entire wedding like you hired a planner.
              <span className="block mt-3 text-ink-soft text-[23px] leading-snug sm:text-[28px] lg:text-[32px] font-normal italic" data-id="element-123" data-mp="3e7l5nw9dmagj">
                Even if you&apos;ve never planned anything bigger than a dinner
                party.
              </span>
            </h1>

            <p className="mt-6 max-w-xl text-[17px] sm:text-[18px] leading-[1.6] text-ink-soft" data-id="element-124" data-mp="2qkwiav1llpsj">
              The complete 6-volume planning system for couples doing this
              without a planner — 300+ pages of real budgets, guest-list math,
              vendor booking order, timelines and day-of scripts. One volume per
              phase, from &ldquo;yes&rdquo; all the way to &ldquo;I do.&rdquo;
            </p>

            <ul className="mt-7 flex flex-wrap gap-x-5 gap-y-2.5" data-id="element-125" data-mp="s3cmgcr3vnrm">
              {miniBadges.map(({
              Icon,
              label
            }) => <li key={label} className="flex items-center gap-2 text-[14px] font-medium text-ink" data-id="element-126" data-mp="n9i7fmmg3wyv">
                  <Icon className="w-4 h-4 text-sage" aria-hidden="true" data-id="element-127" data-mp="degdmdh866py" />
                  {label}
                </li>)}
            </ul>

            <div className="mt-9" data-id="element-128" data-mp="1622hznya1fdv">
              <CtaButton className="w-full sm:w-auto" data-id="element-129" data-mp="162ufx5fcjp7b">
                Get The 12-Month Wedding Plan — Instant Access
              </CtaButton>
              <TrustLine includeDigital className="mt-4" data-id="element-130" data-mp="114ki0n28mai0" />
            </div>
          </div>

          <figure className="lg:order-last mx-auto w-full max-w-sm lg:max-w-none" data-id="element-131" data-mp="x37am8jhxz8z">
            <img src="https://cdn.magicpatterns.com/uploads/vCSVM96iyAbujZaShVLYcm/12-12-hero.png" alt="The six numbered volumes of The 12-Month Wedding Plan standing in a row on an oak table in morning light." width={1712} height={2149} className="w-full rounded object-cover aspect-[4/5] shadow-card" data-id="element-132" data-mp="3lu9wgyz13ua6" />
          </figure>
        </div>
      </div>
    </section>;
}